import React from 'react';
import classnames from 'classnames';
import { scaleToSize } from '../../_helpers';
import imageStyles from './Image.scss';
export var ImageContent = function (_a) {
    var width = _a.width, height = _a.height, file = _a.file, alt = _a.alt, isPixel = _a.isPixel, canZoom = _a.canZoom, onZoom = _a.onZoom, _b = _a.withSrcSet, withSrcSet = _b === void 0 ? false : _b;
    var size = scaleToSize(file, { width: width, height: height });
    return (React.createElement("img", { alt: alt, "aria-hidden": "true", className: classnames(imageStyles['image'], isPixel && imageStyles['pixel'], canZoom && imageStyles['zoomable']), src: file.src, srcSet: withSrcSet ? file.srcSet : '', style: size, onClick: canZoom ? onZoom : undefined }));
};
ImageContent.displayName = 'ImageContent';
export default ImageContent;
//# sourceMappingURL=ImageContent.js.map